import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import OttopayPage from 'containers/pages/ottopay/List'

const Ottopay = ({
  currentUser, location, match,
}) => {
  if (location.pathname === '/ottopay') {
    if (currentUser.permissions && currentUser.permissions.indexOf('manage-ottopay-read') > -1) {
      return <OttopayPage location={location} match={match} />
    }
    return <ForbiddenPage />
  }

  return ''
}

Ottopay.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Ottopay